import React, { useEffect, useState } from "react";
import styles from "./ScreenshotSelector.module.css";
import Screenshot from "./components/Screenshot";
import ScreenshotSelectorModal from "./components/modals/ScreenshotSelectorModal";
import ScreenshotViewerModal from "./components/modals/ScreenshotViewerModal";
import { MessageStatus } from "../../../dataModel/ChatBotDataModel";
import { postHitlMessageApiCall } from "../../../../../store/chatbot.slice";
import { CHAT_MEMBER_ID } from "../../CreateFlow";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../store/common/hooks";

export interface ScreenshotDataModel {
  id: number;
  src: string;
  isSelected: boolean;
  displayOrder?: number;
  name?: string;
  description?: string;
  category?: number;
}

interface ScreenshotSelectorProps {}

const ScreenshotSelector: React.FC<ScreenshotSelectorProps> = () => {
  const [openMoreImage, setOpenMoreImage] = useState(false);
  const [openViewer, setOpenViewer] = useState(false);
  const [selectImage, setSelectedImage] = useState<string | null>(null);
  const [screenshots, setScreenshots] = useState<ScreenshotDataModel[]>([]);

  const aiMessageList = useAppSelector((state) => state.chatbot.aiMessageList);
  const reduxUpdatingContext = useAppSelector(
    (state) => state.chatbot.isUpdatingSmartContext
  );

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (aiMessageList.length > 0) {
      setScreenshots(
        aiMessageList[0].image_urls.map((value: string, index: number) => {
          return { id: index, src: value, isSelected: false };
        })
      );
    }
  }, [aiMessageList]);

  const handleOnClickScreenshot = (screenshot: ScreenshotDataModel) => {
    setSelectedImage(screenshot.src);
    setOpenViewer(true);
  };

  const handleOnClickMoreImage = () => {
    setOpenMoreImage(true);
  };

  const handleImageOpened = (screenshot: ScreenshotDataModel) => {
    setSelectedImage(screenshot.src);
    setOpenViewer(true);
  };

  const handleOnScreenshotSelected = (screenshot: ScreenshotDataModel) => {
    setScreenshots((prev) =>
      prev.map((item) =>
        item.id === screenshot.id
          ? { ...item, isSelected: !screenshot.isSelected }
          : item
      )
    );
  };

  const hitlApiCall = async (
    message: string,
    messageStatus: MessageStatus,
    messageId?: string,
    images?: string[]
  ) => {
    dispatch(
      postHitlMessageApiCall(
        message,
        CHAT_MEMBER_ID,
        messageStatus,
        messageId,
        images
      )
    );
  };

  const handleScreenshotSend = (value: string) => {
    hitlApiCall("", MessageStatus.Approve, undefined, [value]);
  };

  const handleSendMultiple = () => {
    hitlApiCall(
      "",
      MessageStatus.Approve,
      undefined,
      screenshots.filter((value) => value.isSelected).map((val) => val.src)
    );
  };

  return (
    <div className={styles["container"]}>
      {!reduxUpdatingContext ? (
        screenshots.length > 0 &&
        screenshots.slice(0, 2).map((value, index) => {
          return (
            <Screenshot
              key={index}
              screenshot={value}
              state="normal"
              onClickView={() => handleOnClickScreenshot(value)}
              onClickSelect={() => handleOnScreenshotSelected(value)}
            />
          );
        })
      ) : (
        <>
          <Screenshot />
          <Screenshot />
        </>
      )}
      {screenshots.length > 2 && (
        <Screenshot state="more" onClick={handleOnClickMoreImage} />
      )}
      {screenshots.length <= 2 &&
        screenshots.filter((value) => value.isSelected).length > 0 && (
          <Screenshot state="send" onClick={handleSendMultiple} />
        )}
      <ScreenshotSelectorModal
        screenshots={screenshots}
        isOpen={openMoreImage}
        onClose={() => {
          setOpenMoreImage(false);
        }}
        onClickView={handleImageOpened}
        onClickSelect={handleOnScreenshotSelected}
        onSendClicked={() => {
          handleSendMultiple();
          setOpenMoreImage(false);
        }}
      />
      <ScreenshotViewerModal
        isOpen={openViewer}
        onClose={() => {
          setOpenViewer(false);
        }}
        src={selectImage}
        onSendClicked={handleScreenshotSend}
      />
    </div>
  );
};

export default ScreenshotSelector;
